<div mat-dialog-title class="controls-row">
    <div class="spacer"></div>
    <mat-icon (click)="dialogRef.close()" class="pointer">close</mat-icon>
</div>
  
<div mat-dialog-content class="dialog-content">
    <drive-file-viewer [type]="'img'"></drive-file-viewer>
</div>
  